import Button from "@edaz/edazkit/Button/index";
import { View, registerView } from "@frui.ts/views";
import { ViewComponent } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import React from "react";
import { Modal } from "react-bootstrap";
import ReceiptEmailModalViewModel from "viewModels/chargeManagement/chargeManagementEdit/receiptEmailModalViewModel";

const ReceiptEmailModalView: ViewComponent<ReceiptEmailModalViewModel> = observer(({ vm }) => {
  return (
    <Modal size="lg" show={true} onHide={vm.onHide} centered>
      <Modal.Header className="d-flex justify-content-center text-center">
        <Modal.Title>{vm.translate("sendReceiptToEmail")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="pt-4 px-0 px-sm-4 px-lg-7 mt-n4">
          <View vm={vm.contactViewModel} />
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center">
        <Button className="px-7 px-sm-10" onClick={vm.onSubmit}>
          {vm.translate("confirmChange")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
});

registerView(ReceiptEmailModalView, ReceiptEmailModalViewModel);
